import { RootReducer } from '../rootReducer';

import { FeaturesState } from './reducer';

export const selectFeaturesStatus = (state: RootReducer): { flagsResolved: boolean; featuresLoaded: boolean } => ({
    flagsResolved: state.features.flagsResolved,
    featuresLoaded: state.features.featuresLoaded,
});

export const selectResolvedFlags = (state: RootReducer): FeaturesState['flags'] => state.features.flags;

export const selectEnabledFeatures = (state: RootReducer): FeaturesState['features'] => state.features.features;

/** Portal gate: nav access is fully resolved (user settled + flags + features). */
export const selectIsNavReady = (state: RootReducer): boolean =>
    Boolean(state.auth.isComplete && state.features.flagsResolved && state.features.featuresLoaded);
